import { Box, Typography } from "@mui/material";
import { memo } from "react";

export const cleanOrientationContent = (content: string) =>
  content
    .replace(/<\/?(html|body)[^>]*>/gi, "")
    .replace(/<p[^>]*>\s*(?:&nbsp;|Â |\s)*<\/p>/gi, "")
    .replace(/<p[^>]*>\s*_+\s*<\/p>/gi, "<hr />")
    .replace(/(?:&nbsp;|Â )+/g, " ")
    .replace(/\*/g, "")
    .trim();

interface IOrientationCardProps {
  title: string;
  content: string;
}

const OrientationCard: React.FC<IOrientationCardProps> = ({
  title,
  content,
}) => (
  <Box
    sx={(theme) => ({
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 1,
      backgroundColor:
        theme.palette.mode === "light"
          ? theme.palette.grey[50]
          : theme.palette.background.paper,
      p: { xs: 2, sm: 2.5 },
    })}
  >
    <Typography
      variant="subtitle1"
      fontWeight={700}
      color="text.primary"
      sx={{ mb: 1.5 }}
    >
      {title}
    </Typography>
    <Typography
      component="div"
      variant="body2"
      sx={{
        color: "text.primary",
        fontSize: 15,
        lineHeight: 1.7,
        wordBreak: "break-word",
        "& p": {
          m: 0,
          mb: 1.25,
        },
        "& p:last-child": {
          mb: 0,
        },
        "& ul, & ol": {
          pl: 3,
          my: 1,
        },
        "& li": {
          mb: 0.5,
        },
        "& strong, & b": {
          fontWeight: 700,
        },
        "& hr": {
          border: 0,
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          my: 2,
          width: "100%",
        },
        "& span, & font": {
          fontFamily: "inherit !important",
          fontSize: "inherit !important",
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: cleanOrientationContent(content),
      }}
    />
  </Box>
);

export default memo(OrientationCard);
